// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__md-VU","content":"styles_content__2Dg_W","checkbox":"styles_checkbox__3MNwu","checkboxLabel":"styles_checkboxLabel__sBXAS"};